<template>
  <v-card :class="['external-links']">
    <v-card-title v-if="title || subTitle" primary-title :class="['py-2']">
      <div>
        <div :class="['headline', 'mb-2']" v-html="title" v-if="title" />
        <div v-html="subTitle" v-if="subTitle" />
      </div>
    </v-card-title>
    <v-card-text :class="['pt-0']">
      <v-list :dense="dense" three-line>
        <template v-for="(link, index) in links">
          <v-list-tile rel="noopener" :key="link.title" :target="target" :href="link.url" :title="link.description">
            <v-list-tile-avatar v-if="icon">
              <v-icon :class="['mt-4']" medium>{{ icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="link.title" />
              <v-list-tile-sub-title v-html="link.description" v-if="link.description" />
            </v-list-tile-content>
            <v-list-tile-action v-if="actionIcon">
              <v-icon>{{ actionIcon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :inset="itemDividerInset" :key="index" v-if="index < links.length - 1" />
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import links from '../helpers/external-links'

export default {
  name: 'ExternalLinks',
  data () {
    return {
      links
    }
  },
  props: {
    /**
     * Left icon
     * @string
     */
    icon: {
      type: String,
      required: false,
      default: 'mdi-code-tags'
    },
    /**
     * List title
     * @string
     */
    title: {
      type: String,
      required: false,
      default: null
    },
    /**
     * List sub title
     * @string
     */
    subTitle: {
      type: String,
      required: false,
      default: null
    },
    /**
     * Link target
     * @string
     */
    target: {
      type: String,
      required: false,
      default: '_blank'
    },
    /**
     * Larger or smaller list
     * @boolean
     */
    dense: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Inset or outset tile divider
     * @boolean
     */
    itemDividerInset: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Right icon
     * @boolean
     */
    actionIcon: {
      type: String,
      required: false,
      default: 'mdi-open-in-new'
    }
  }
}
</script>
<style>
.external-links .v-list__tile
{
  height: auto !important;
  min-height: 76px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/external-links.vue